<script>
  /* eslint-disable import/no-mutable-exports */
  import formatMoney from "../../utils/currency.js";
  import JudgeMeRatingWidget from "./JudgeMeRatingWidget.svelte";
  import BikeFeatures from "./BikeFeatures.svelte";
  import ProductCardStockLabel from "./ProductCardStockLabel.svelte";
  import ProductCardVariantButtons from "./ProductCardVariantButtons.svelte";
  import ProductCardColourSwatches from "./ProductCardColourSwatches.svelte";
  import WishlistTrigger from "./WishlistTrigger.svelte";

  /** {Product} product */
  export let product;
  /*** {Boolean} swiperSlide */
  export let swiperSlide = false;
  /** {Number} mobileColumnSpan */
  export let mobileColumnSpan = 2;
  /** {Array} doNotRender */
  export let doNotRender = [];
</script>

<div class="{swiperSlide ? 'swiper-slide' : ''} col-span-{mobileColumnSpan} lg:col-span-1" data-cy="product-card" data-cy-product-stock="{product.stockLabel}">
  <div class="w-full relative bg-product-image-blend group" data-image-container>
    <span class="absolute right-1.5 top-1 z-20 flex justify-end w-full">
      <WishlistTrigger product="{product}" productVariantId="{product.variants[0].id}" productImageURL="{product.sizedProgressiveImage(384)}" />
    </span>

    <span class="absolute bottom-0 z-20 flex justify-end w-full">
      <ProductCardStockLabel product="{product}" dynamic="{product.modelSource === 'swym'}" />
    </span>

    <a href="{product.url}" class="block aspect-w-1 aspect-h-1 relative h-full">
      <img
        src="{product.sizedProgressiveImage(384)}"
        alt="{product.title}"
        class="object-contain mix-blend-multiply w-full h-full"
        loading="lazy"
      >
    </a>

    {#if product.optionNames.length > 0 && !product.hasOnlyDefaultVariant}
      <div
        class="
          absolute bottom-0 left-0
          w-full
          bg-white/60 backdrop-blur-md
          pt-1/24 pb-3/24 px-1/24
          transition-[opacity] duration-250
          hidden lg:block lg:opacity-0 lg:pointer-events-none
          lg:group-hover:opacity-100 lg:group-hover:pointer-events-auto
        "
      >
        <p class="b5 uppercase tracking-widest mb-1 text-center">
          Available {product.optionNames[0]}s
        </p>
        <div class="flex flex-wrap gap-1">
          <ProductCardVariantButtons product="{product}" max="3" />
        </div>
      </div>
    {/if}

    {#if product.optionNames.includes('Colour')}
      <ProductCardColourSwatches product="{product}" />
    {/if}
  </div>
  <a href="{product.url}"
     class="flex flex-col justify-between py-1 px-1 min-h-[120px] md:min-h-[145px]">
    <div>
      {#if product.vendor}
        <p class="text-xs font-normal uppercase tracking-widest">{product.vendor}</p>
      {/if}
      <div class="flex flex-col lg:flex-row justify-between font-normal mb-0.5">
        <p class="lg:w-3/4">
          {product.title}
        </p>
        <p class="lg:w-1/4 lg:text-right b3 flex flex-wrap justify-between items-end lg:block">
          {formatMoney(product.price)}

          {#if product.compareAtPrice}
            <span class="line-through block b5 block">{formatMoney(product.compareAtPrice)}</span>

            <span class="text-[#B30000] lg:block b6 font-medium">
              Save {formatMoney(product.compareAtPrice - product.price)}
            </span>
          {/if}
        </p>
      </div>
    </div>

    <div class="flex flex-col lg:flex-col-reverse">
      {#if product.features?.length}
        <div class="mt-0 mb-0.5 lg:mt-1 lg:mb-0">
          <BikeFeatures features="{product.features}" />
        </div>
      {/if}

      <div class="my-0 lg:my-1">
        {#if !doNotRender.includes('reviews')}
          <JudgeMeRatingWidget productHandle="{product.handle}" />
        {/if}
      </div>
    </div>
  </a>
</div>
